module.exports = __webpack_public_path__ + "static/pineapple-c6a59b0aeb4459182245f7f2cbbe478b.jpg";